<template>
	<div class="interval-picker">
		<div class="picker-container">
			<v-date-picker
				class="cursor-pointer"
				:value="value.startDate"
				color="indigo"
				:max-date="value.endDate"
				@input="handleStartDateChange"
			>
				<template #default="{ togglePopover }">
					<div class="w-full">
						<div
							class="datepicker"
							@click="togglePopover({ placement: 'auto-start' })"
						>
							<Icon
								icon="fa-solid:calendar"
								class="calendar-icon"
							/>
							<span class="picker-label">{{ $t('inicio') }}</span>
							<span class="date-value">{{ formatDate(value.startDate) }}</span>
						</div>
					</div>
				</template>
			</v-date-picker>
		</div>

		<div class="picker-container">
			<v-date-picker
				class="cursor-pointer"
				:value="value.endDate"
				color="indigo"
				:min-date="value.startDate"
				@input="handleEndDateChange"
			>
				<template #default="{ togglePopover }">
					<div class="w-full">
						<div
							class="datepicker"
							@click="togglePopover({ placement: 'auto-start' })"
						>
							<Icon
								icon="fa-solid:calendar"
								class="calendar-icon"
							/>
							<span class="picker-label">{{ $t('fim') }}</span>
							<span class="date-value">{{ formatDate(value.endDate) }}</span>
						</div>
					</div>
				</template>
			</v-date-picker>
		</div>
	</div>
</template>

<script>
import { Icon } from '@iconify/vue2'

export default {
	name: 'DateIntervalPicker',

	components: {
		Icon,
	},

	props: {
		value: {
			type: Object,
			required: true,
		},
	},

	mounted() {
		console.warn(
			'DataPicker está depreciado, considere utilizar o DataPicker da lib @treevia/smartforest-ui',
		)
	},

	methods: {
		handleStartDateChange(date) {
			this.$emit('input', {
				startDate: date.toISOString(),
				endDate: this.value.endDate,
			})
		},

		handleEndDateChange(date) {
			this.$emit('input', {
				startDate: this.value.startDate,
				endDate: date.toISOString(),
			})
		},

		formatDate(isoDate) {
			if (!isoDate) return ''
			const date = new Date(isoDate)
			return date.toLocaleDateString('pt-BR')
		},
	},
}
</script>

<style scoped>
.interval-picker {
	display: flex;
	gap: 1rem;
	width: 50px;
}

.picker-container {
	flex: 1;
}

.datepicker {
	@apply border border-[#737576] rounded-[4px] flex items-center px-3 bg-white cursor-pointer;
	height: 38px;
}

.picker-label {
	@apply text-xs font-medium text-gray-600 mr-2;
	margin-left: 0.5rem;
}

.date-value {
	@apply flex-1 text-sm;
}

.calendar-icon {
	@apply text-gray-600 ml-2;
	margin-left: 0.5rem;
}
</style>
